export default __webpack_public_path__ + "static/media/grafema_pilates_10.fe1bb15b.jpg";